import React from 'react'
import { Box, Button, Paper } from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'
import { CSVLink } from 'react-csv'
import { Table } from 'react-bootstrap'
import SettlementDetailContextHeader from '../../components/SettlementDetailContextHeader'
import {
  SETTLEMENT_DELIVERED_PRODUCTS_DOWNLOAD_LABEL,
  SETTLEMENT_DELIVERED_PRODUCTS_EMPTY_STATE,
  SETTLEMENT_DELIVERED_PRODUCTS_MISSING_VALUE,
  SETTLEMENT_DELIVERED_PRODUCTS_TABLE_HEADERS,
  SETTLEMENT_DELIVERED_PRODUCTS_TITLE
} from '../../constants/settlementDetailsConstants'
import {
  UI_COLOR_ACCENT_ORANGE_ALT,
  UI_COLOR_ACCENT_ORANGE_BRIGHT,
  UI_COLOR_WHITE
} from '../../constants/uiColors'
import { buildDeliveredProductsRows } from '../helpers/detailsHelpers'

const formatQuantity = (quantity) => {
  const number = Number(quantity || 0)
  if (!Number.isFinite(number)) return 0

  return Number.isInteger(number) ? number : Number(number.toFixed(2))
}

export default function SettlementDeliveredProductsTab({
  settlement = null,
  rows = null,
  csvData,
  filename,
  actions = null
}) {
  const deliveredProducts = React.useMemo(
    () => rows || buildDeliveredProductsRows(settlement),
    [rows, settlement]
  )

  const downloadButton =
    deliveredProducts.length > 0 ? (
      <Button
        component={CSVLink}
        data={csvData}
        filename={filename}
        variant="contained"
        startIcon={<DownloadIcon />}
        sx={{
          textDecoration: 'none',
          backgroundColor: UI_COLOR_ACCENT_ORANGE_BRIGHT,
          color: `${UI_COLOR_WHITE} !important`,
          '& .MuiButton-startIcon': {
            color: `${UI_COLOR_WHITE} !important`
          },
          '&:hover': {
            backgroundColor: UI_COLOR_ACCENT_ORANGE_ALT
          }
        }}
      >
        {SETTLEMENT_DELIVERED_PRODUCTS_DOWNLOAD_LABEL}
      </Button>
    ) : (
      <Button
        variant="contained"
        startIcon={<DownloadIcon />}
        disabled
        sx={{
          backgroundColor: UI_COLOR_ACCENT_ORANGE_BRIGHT,
          color: `${UI_COLOR_WHITE} !important`,
          '& .MuiButton-startIcon': {
            color: `${UI_COLOR_WHITE} !important`
          }
        }}
      >
        {SETTLEMENT_DELIVERED_PRODUCTS_DOWNLOAD_LABEL}
      </Button>
    )

  return (
    <Box>
      <SettlementDetailContextHeader
        title={SETTLEMENT_DELIVERED_PRODUCTS_TITLE}
        settlement={settlement}
        actions={actions || downloadButton}
      />

      <Paper elevation={0} sx={{ overflow: 'hidden' }}>
        <Table hover responsive>
          <thead className="table-header-gray-mui">
            <tr>
              {SETTLEMENT_DELIVERED_PRODUCTS_TABLE_HEADERS.map((header) => (
                <th key={header}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {deliveredProducts.length > 0 ? (
              deliveredProducts.map((product, index) => (
                <tr key={product.id || `${product.productCode}-${index}`}>
                  <td className="td-text-limited">
                    {product.productCode || SETTLEMENT_DELIVERED_PRODUCTS_MISSING_VALUE}
                  </td>
                  <td className="td-text-limited">
                    {product.barcode || SETTLEMENT_DELIVERED_PRODUCTS_MISSING_VALUE}
                  </td>
                  <td className="td-text-limited">
                    {product.productName || SETTLEMENT_DELIVERED_PRODUCTS_MISSING_VALUE}
                  </td>
                  <td className="td-text-limited">
                    {product.unitOfSale || SETTLEMENT_DELIVERED_PRODUCTS_MISSING_VALUE}
                  </td>
                  <td className="td-text-limited">{formatQuantity(product.quantity)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">{SETTLEMENT_DELIVERED_PRODUCTS_EMPTY_STATE}</td>
              </tr>
            )}
          </tbody>
        </Table>
      </Paper>
    </Box>
  )
}
